import Demo from './demo'
import Emergency from './emergency'
import UnifiedRelease from './unifiedRelease'
import serviceAlarm from './serviceAlarm'
import seekHelp from './seekHelp'
import Area from './area'
import Monitor from './monitor'
import Broadcast from './broadcast'
import CarPark from './carpark'
import ClusterServer from './clusterServer'
import LED from './led'
import Equipment from './equipment'
import Cableway from './cableway'
import Wifi from './wifi'
import Opinion from './Opinion'
import Face from './Face'
import MaterialManage from './MaterialManage'
import POI from './poi'
import SMS from './sms'
import SystemLog from './systemLog'
import DataDetection from './dataDetection'
import Home from './home'
import VehicleScheduling from './vehicleScheduling'
import Map from './map'
import Uniformauth from './uniformauth'
import Weather from './weather'
import SmartToilet from './smartToilet'
import SmartTrash from './smartTrash'
import Complaint from './complaint'
import UniformSysConfig from './uniformSysConfig'
import TourReport from './TourReport'
import TstcIndex from './TstcIndex'
import Patrol from './Patrol'
import Onduty from './onduty'
import enviromentData from './enviromentData'
import securitySituation from './securitySituation'
import Passenger from './passenger'
import Ticket from './ticket'
import SignIn from './sign'

const plugins = {
    Demo,
    Emergency,
    UnifiedRelease,
    serviceAlarm,
    seekHelp,
    Area,
    Monitor,
    Broadcast,
    CarPark,
    ClusterServer,
    LED,
    Equipment,
    Cableway,
    Wifi,
    Opinion,
    MaterialManage,
    POI,
    SMS,
    SystemLog,
    DataDetection,
    Home,
    VehicleScheduling,
    Map,
    Uniformauth,
    Weather,
    SmartToilet,
    SmartTrash,
    Complaint,
    Face,
    UniformSysConfig,
    TourReport,
    TstcIndex,
    Patrol,
    Onduty,
    enviromentData,
    securitySituation,
    Passenger,
    Ticket,
    SignIn
};

export default plugins;